export function currentBillDate() {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();

  const billDate = new Date(year, month - 1, 1);
  const billYear = billDate.getFullYear();
  const billMonth = billDate.getMonth() + 1;
  const filledMonth =
    String(billMonth).length === 1 ? `0${billMonth}` : billMonth;

  return `${billYear}-${filledMonth}`;
}
